import {
  getApplicationName,
  getApplicationVersion,
  getArea,
  getEnvironment,
} from "../environmentUtils";

const getColor = (type: string) => {
  switch (type) {
    case "primary":
      return "#2d8cf0";
    case "success":
      return "#19be6b";
    case "warning":
      return "#ff9900";
    case "error":
      return "#ed4014";
    case "text":
      return "#000000";
    default:
      return "#515a6e";
  }
};

const capsule = (
  title?: string,
  info?: string,
  type = "primary",
  ...args: []
) => {
  console.log(
    `%c ${title} %c ${info} %c`,
    "background:#35495E; padding: 1px; border-radius: 3px 0 0 3px; color: #fff;",
    `background:${getColor(
      type,
    )}; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff;`,
    "background:transparent",
    ...args,
  );
};

export const consoleAppInfo = () => {
  capsule("AppName", getApplicationName(), "primary");
  capsule("Version", getApplicationVersion(), "success");
  capsule("Environment", getEnvironment(), "primary");
  capsule("Area", getArea(), "warning");
};
